import { useState, useEffect } from 'react';
import { getUserSessionRegions, RegionsByZipCode } from './regionalInfoHelpers';

/**
 * Used to read regions from sessionStorage only after hydration step has finished.
 */
export function useUserSessionRegions(): RegionsByZipCode[] | undefined {
    const [regions, setRegions] = useState<RegionsByZipCode[] | undefined>(undefined);

    useEffect(() => {
        setRegions(getUserSessionRegions());
    }, [setRegions]);

    return regions;
}
